import { render, staticRenderFns } from "./idinfoaddorupdate.vue?vue&type=template&id=2ce6faf8"
import script from "./idinfoaddorupdate.vue?vue&type=script&lang=js"
export * from "./idinfoaddorupdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports